//设置cookie
function setCookie(c_name, value, expire, path) {
    var str = "";
    if((!!c_name) && (!!value)) {
        str = c_name + "=" + escape(value);
        if(!!path) {
            str = str + ";path="+path;
        };

        if(parseInt(expire) > 0) {
            var date=new Date();
            date.setSeconds(date.getSeconds()+expire);
            str = str + ";expires=" + date.toGMTString();
        };
        document.cookie = str;
    };
};

//获取cookie
function getCookie(c_name) {
    if(document.cookie.length>0) {
        var c_start=document.cookie.indexOf(c_name + "=");
        if(c_start != -1){
            c_start = c_start + c_name.length + 1;
            var c_end=document.cookie.indexOf(";",c_start);
            if(c_end == -1) c_end=document.cookie.length;
            return unescape(document.cookie.substring(c_start,c_end));
        };
    };
    return "";
};

//toDOuble
function toDouble(n) {
    let num = parseInt(n);
    return num > 9 ? num + '' : '0' + num;
};

//日期格式化
function dateFormat(fmt, date) {
    var o = {
        'M+': date.getMonth() + 1, // 月份
        'd+': date.getDate(), // 日
        'h+': date.getHours(), // 小时
        'm+': date.getMinutes(), // 分
        's+': date.getSeconds(), // 秒
        'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
        'S': date.getMilliseconds() // 毫秒
    };

    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
    }
    for (let k in o) {
        if (new RegExp('(' + k + ')').test(fmt)) {
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
        }
    }
    return fmt;
};

function transformDate(stamp) {
    var dateTimeStamp = new Date(stamp);
    var now = new Date();
    var yearC = now.getFullYear() - dateTimeStamp.getFullYear();
    var monthC = now.getMonth() - dateTimeStamp.getMonth();
    var dayC = now.getDate() - dateTimeStamp.getDate();
    var hourC = now.getHours() - dateTimeStamp.getHours();
    var minC = now.getMinutes() - dateTimeStamp.getMinutes();

    if (yearC >= 1) {
        return dateFormat('yyyy-MM-dd', new Date(stamp));
    } else if (monthC > 0 || (monthC === 0 && dayC > 2)) {
        return dateFormat('MM-dd hh:mm', new Date(stamp));
    } else if (dayC === 2) {
        return `前天 ${dateFormat('hh:mm', new Date(stamp))}`;
    } else if (dayC === 1) {
        return `昨天 ${dateFormat('hh:mm', new Date(stamp))}`;
    } else if (hourC > 0) {
        return `${hourC}小时前`;
    } else if (minC >= 15) {
        return `${minC}分钟前`;
    } else {
        return toDouble(dateTimeStamp.getHours()) + ':' + toDouble(dateTimeStamp.getMinutes());
    }
};

//通过时间戳获取全格式日期
function getFormatDate(stmp, format="yyyy-MM-dd") {
    if(parseInt(stmp)) {
        var date = new Date(stmp * 1000);
        return dateFormat(format, date)
    };
    return '';
};

//字符串截取函数
function wordSlice(str, num = 40) {
    if(str && str.length) {
        if(str.length > num) {
            return str.substring(0, num) + '...';
        };
        return str;
    };
    return '';
};

//生成指定范围随机数
function createRandomNum(minNum, maxNum) {
    let Range = maxNum - minNum;
    return (minNum + Math.round( Math.random() * Range));
};

//生成随机字符串
function generateRandomStr(n = 6) {
    let arr = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q','r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'];
    let str = '';
    for(let i = 0; i < n; i++) {
        str += arr[createRandomNum(0, arr.length - 1)];
    };
    return str + new Date().getTime();
};

//长度验证
function length_check(str, minLength, maxLength) {
    var minLen = (parseInt(minLength) > 0) ? parseInt(minLength) : 0;
    var maxLen = (parseInt(maxLength) > 0) ? parseInt(maxLength) : 0;
    var len = str.length;

    //有最小长度限制
    if(minLen) {
        if(len < minLen) {
            return true;
        };
    };

    //有最大长度小限制
    if(maxLen) {
        if(len > maxLen) {
            return true;
        };
    };
    return false;
};

//手机号验证
function phoneCheck(phone) {
    let myreg=/^[1][3,4,5,7,8,9][0-9]{9}$/;
    if (!myreg.test(phone)) {
        return false;
    } else {
        return true;
    };
};

//转换非整数
function numConvert(num) {
    num = parseInt(num);
    if((!num) || (num < 0)) {
        num = 0;
    };
    return num;
};

//检测字符串是否为空
function isEmpty(str) {
    str = (!!str) && str.trim();
    if((!str) || (str.length==0)) {
        return true;
    };
    return false;
};

//特殊字符检测
function specialChars(str) {
    const re =/[<>]/im;
    if (re.test(str)) {
        return true;
    };
    return false;
};

//字符串常规验证
function strValidate(val, name, allowEmpty, minLen, maxLen) {
    name = name || '字段';

    //是否允许为空
    allowEmpty = allowEmpty || false;

    //最小值
    minLen = (parseInt(minLen) > 0) ? parseInt(minLen) : 0;

    //最大值
    maxLen = (parseInt(maxLen) > 0) ? parseInt(maxLen) : 300;

    //再判断表单是否允许为空
    if(allowEmpty) {
        //允许为空
        if(!isEmpty(val)) {
            return strCheck(val, name, minLen, maxLen);
        } else {
            return true;
        };
    } else {
        //不允许为空
        if(isEmpty(val)) {
            alert(name + '不能为空');
            return false;
        } else {
            return strCheck(val, name, minLen, maxLen);
        };
    };
};

//验证字段的合法性
function strCheck(val, name, minLen, maxLen) {
    //验证是否包含特殊字符
    if(specialChars(val)) {
        alert(name + '含有特殊字符');
        return false;
    };

    //验证长度
    if(length_check(val, minLen, maxLen)) {
        alert(name + '长度不合法');
        return false;
    };
    return val;
};

//获取当前的协议、域名
function getDomain() {
    return window.location.protocol+"//"+window.location.host + '/';
};

//下载文件
function downloadFile(stream, filename) {
    if(stream && filename) {
        let blob = new Blob([stream], {
            type: "application/octet-stream;charset=UTF-8"
        });
        let url = window.URL.createObjectURL(blob);
        let a = document.createElement('a');
        a.href = url;
        a.download = filename;
        a.click();
        document.body.append(a);
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
    };
};

export {
    setCookie,
    getCookie,
    toDouble,
    dateFormat,
    transformDate,
    getFormatDate,
    wordSlice,
    createRandomNum,
    generateRandomStr,
    length_check,
    phoneCheck,
    numConvert,
    isEmpty,
    specialChars,
    strValidate,
    getDomain,
    downloadFile
};

